module.exports = __webpack_public_path__ + "static/media/sports_32.71887aaf.jpg";